export default __webpack_public_path__ + "static/media/loading.ce45ccbe.svg";